// import React, { createContext, useState, useEffect, useMemo } from "react";
// import {
//   fetchPermissions,
//   createPermission,
//   updatePermission,
//   getPermissionDetails,
// } from "../services/permissionService";

// export const PermissionContext = createContext();

// export const PermissionProvider = ({ children }) => {
//   const [permissions, setPermissions] = useState([]);
//   const [currentPermission, setCurrentPermission] = useState(null);
//   const [loading, setLoading] = useState(false);

//   // Load all permissions
//   const loadPermissions = async (token) => {
//     setLoading(true);
//     try {
//       const fetchedPermissions = await fetchPermissions(token);
//       setPermissions(fetchedPermissions);
//     } catch (error) {
//       console.error("Error loading permissions:", error.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Fetch details for a specific permission
//   const fetchPermissionDetails = async (token, permissionId) => {
//     try {
//       const permission = await getPermissionDetails(token, permissionId);
//       setCurrentPermission(permission);
//     } catch (error) {
//       console.error("Error fetching permission details:", error.message);
//     }
//   };

//   // Add a new permission
//   const addPermission = async (token, permissionData) => {
//     try {
//       const newPermission = await createPermission(token, permissionData);
//       setPermissions((prevPermissions) => [...prevPermissions, newPermission]);
//     } catch (error) {
//       console.error("Error adding permission:", error.message);
//     }
//   };

//   // Edit an existing permission
//   const editPermission = async (token, permissionId, permissionData) => {
//     try {
//       const updatedPermission = await updatePermission(token, permissionId, permissionData);
//       setPermissions((prevPermissions) =>
//         prevPermissions.map((permission) =>
//           permission.id === updatedPermission.id ? updatedPermission : permission
//         )
//       );
//       setCurrentPermission(updatedPermission);
//     } catch (error) {
//       console.error("Error editing permission:", error.message);
//     }
//   };

//   // Memoize the context value
//   const value = useMemo(
//     () => ({
//       permissions,
//       currentPermission,
//       loading,
//       loadPermissions,
//       fetchPermissionDetails,
//       addPermission,
//       editPermission,
//     }),
//     [permissions, currentPermission, loading] // Recalculate the value only when these dependencies change
//   );

//   return <PermissionContext.Provider value={value}>{children}</PermissionContext.Provider>;
// };


// new code

import React, { createContext, useState, useCallback, useMemo } from "react";
import {
  fetchPermissions,
  createPermission,
  updatePermission,
  getPermissionDetails,
  deletePermission,
} from "../services/permissionService";

export const PermissionContext = createContext();

export const PermissionProvider = ({ children }) => {
  const [permissions, setPermissions] = useState([]);
  const [currentPermission, setCurrentPermission] = useState(null);
  const [loading, setLoading] = useState(false);

  // Load all permissions (memoized)
  const loadPermissions = useCallback(async (token) => {
    setLoading(true);
    try {
      const fetchedPermissions = await fetchPermissions(token);
      setPermissions(fetchedPermissions);
    } catch (error) {
      console.error("Error loading permissions:", error.message);
    } finally {
      setLoading(false);
    }
  }, []);

  // Fetch details for a specific permission
  const fetchPermissionDetails = useCallback(async (token, permissionId) => {
    try {
      const permission = await getPermissionDetails(token, permissionId);
      setCurrentPermission(permission);
    } catch (error) {
      console.error("Error fetching permission details:", error.message);
    }
  }, []);

  // Add a new permission
  const addPermission = useCallback(async (token, permissionData) => {
    try {
      const newPermission = await createPermission(token, permissionData);
      // setPermissions((prevPermissions) => [...prevPermissions, newPermission]);
      setPermissions((prevPermissions) => [newPermission, ...prevPermissions]);

    } catch (error) {
      console.error("Error adding permission:", error.message);
    }
  }, []);

  // Edit an existing permission
  const editPermission = useCallback(async (token, permissionId, permissionData) => {
    try {
      const updatedPermission = await updatePermission(token, permissionId, permissionData);
      setPermissions((prevPermissions) =>
        prevPermissions.map((permission) =>
          permission.id === updatedPermission.id ? updatedPermission : permission
        )
      );
      setCurrentPermission(updatedPermission);
    } catch (error) {
      console.error("Error editing permission:", error.message);
    }
  }, []);

  const removePermission = useCallback(async (token, permissionId) => {
    try {
      await deletePermission(token, permissionId);
      setPermissions((prevPermissions) =>
        prevPermissions.filter((permission) => permission.id !== permissionId)
      );
    } catch (error) {
      console.error("Error deleting permission:", error.message);
    }
  }, []);

  // Memoize the context value
  const value = useMemo(
    () => ({
      permissions,
      currentPermission,
      loading,
      loadPermissions,
      fetchPermissionDetails,
      addPermission,
      editPermission,
      removePermission
    }),
    [permissions, currentPermission, loading, loadPermissions, fetchPermissionDetails, addPermission, editPermission, removePermission]
  );

  return <PermissionContext.Provider value={value}>{children}</PermissionContext.Provider>;
};


